import { SNACKBAR_CLEAR, SHOW_SNACKBAR } from '../actionTypes';

const showSnackBar = (message, severity = 'success', duration) => ({
  type: SHOW_SNACKBAR,
  message,
  severity,
  duration,
});

export const showErrorSnackbar = (message) => {
  return (dispatch) => {
    dispatch(showSnackBar(message, 'error'));
  };
};

export const showInfoSnackbar = (message) => {
  return (dispatch) => {
    dispatch(showSnackBar(message, 'info'));
  };
};

export const showSuccessSnackbar = (
  message,
  severity = 'success',
  duration = 6000
) => {
  return (dispatch) => {
    dispatch(showSnackBar(message, severity, duration));
  };
};

export const clearSnackbar = () => {
  return (dispatch) => {
    dispatch({ type: SNACKBAR_CLEAR });
  };
};
